<template>
  <div
    v-if="show"
    ref="floatingRoot"
    class="cookie-consent"
    :style="floatingStyle"
    :dir="isHebrew ? 'rtl' : 'ltr'">
    <p>
      🍪 {{ t('cookieConsentMessage') }}
      <a href="/privacy_policy" target="_blank">{{ t('cookieConsentReadMore') }}</a>
    </p>
    <button @click="acceptCookies">✓ {{ t('cookieConsentAgree') }}</button>
  </div>
</template>

<script>
import { translationMixin } from '@/mixins/translationMixin';
import {
  getFloatingItemStyle,
  registerFloatingItem,
  unregisterFloatingItem,
  updateFloatingItem,
} from "@/services/floatingItems";

export default {
  name: "CookieConsent",
  mixins: [translationMixin],
  data() {
    return {
      show: false,
      floatingId: "floating-cookie-consent",
    };
  },
  computed: {
    floatingStyle() {
      return getFloatingItemStyle(this.floatingId);
    },
  },
  mounted() {
    registerFloatingItem({
      id: this.floatingId,
      priority: 10,
      anchor: "full",
      zIndex: 1100,
    });

    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      this.show = true;
      this.syncFloatingState();
    }
  },
  beforeDestroy() {
    unregisterFloatingItem(this.floatingId);
  },
  watch: {
    show() {
      this.syncFloatingState();
    },
  },
  methods: {
    acceptCookies() {
      localStorage.setItem("cookie_consent", "true");
      this.show = false;
    },
    syncFloatingState() {
      this.$nextTick(() => {
        const root = this.$refs.floatingRoot;
        updateFloatingItem(this.floatingId, {
          visible: !!this.show,
          height: this.show && root ? root.offsetHeight : 0,
        });
      });
    },
  },
};
</script>

<style scoped>
.cookie-consent {
  background: #f0f0f0;
  padding: 1rem;
  text-align: center;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}
.cookie-consent p {
  margin: 0 0 0.5rem 0;
}
.cookie-consent button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 4px;
}
.cookie-consent a {
  margin-right: 5px;
  color: #007bff;
  text-decoration: underline;
}
button {
  margin-top: 4rem; /* or margin-left if side-by-side */
}
</style>
